module.exports = __webpack_public_path__ + "img/icon-balanced.459fd7b1.svg";